module.exports = __webpack_public_path__ + "static/media/calculator.bca322db.svg";